import PortfolioDefaulEmpty from './PortfolioDefaulEmpty.component';

export default PortfolioDefaulEmpty;
